import React, { useMemo, useState } from 'react';

const S = {
  panel: {
    position: 'sticky',
    top: 8,
    border: '1px solid var(--border)',
    borderRadius: 12,
    background: 'var(--bg-subtle)',
    overflow: 'hidden',
    minWidth: 0,
  },
  head: { padding: '8px 9px', borderBottom: '1px solid var(--border)', background: 'var(--bg-card)' },
  headTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 },
  title: { fontSize: 12, fontWeight: 950, color: 'var(--text)' },
  sub: { marginTop: 2, fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.3 },
  criteria: { marginTop: 4, fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.3 },
  count: {
    flex: '0 0 auto',
    borderRadius: 999,
    padding: '2px 7px',
    background: 'rgba(37,99,235,0.10)',
    color: '#2563eb',
    fontSize: 10,
    fontWeight: 950,
  },
  body: { padding: 7, display: 'flex', flexDirection: 'column', gap: 5 },
  search: {
    height: 29,
    width: '100%',
    minWidth: 0,
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '0 10px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 11,
    outline: 'none',
    boxSizing: 'border-box',
  },
  item: {
    width: '100%',
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '5px 7px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    textAlign: 'left',
    cursor: 'pointer',
    boxSizing: 'border-box',
  },
  row: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6, minWidth: 0 },
  name: { minWidth: 0, fontSize: 11, fontWeight: 950, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  meta: { flex: '0 0 auto', maxWidth: 86, fontSize: 10, color: 'var(--text-muted)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  empty: { padding: 10, color: 'var(--text-muted)', fontSize: 11, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'center' },
  clearBtn: {
    height: 24,
    border: '1px solid var(--border)',
    borderRadius: 7,
    padding: '0 8px',
    background: 'var(--bg-card)',
    color: 'var(--text-sub)',
    fontSize: 10,
    fontWeight: 900,
    cursor: 'pointer',
  },
  badge: {
    display: 'inline-flex',
    marginLeft: 5,
    borderRadius: 999,
    padding: '1px 5px',
    background: 'rgba(100,116,139,0.12)',
    color: 'var(--text-muted)',
    fontSize: 9,
    fontWeight: 950,
  },
};

export function retireLabel(user) {
  if (user?.is_active !== false && !user?.resign_date) return '';
  const date = String(user?.resign_date || '').slice(0, 10);
  return date ? `퇴사 ${date.slice(5).replace('-', '/')}` : '퇴사';
}

export function UnassignedConsultantPool({ consultants = [], basisLabel = '선택월', saving, onDragStart, onDragEnd, onPick }) {
  const [keyword, setKeyword] = useState('');
  const filtered = useMemo(() => {
    const q = keyword.trim().toLowerCase();
    if (!q) return consultants;
    return consultants.filter((user) => (
      String(user.name || '').toLowerCase().includes(q)
      || String(user.department || '').toLowerCase().includes(q)
    ));
  }, [consultants, keyword]);

  return (
    <aside style={S.panel}>
      <div style={S.head}>
        <div style={S.headTop}>
          <div style={S.title}>배정 안 된 직원</div>
          <span style={S.count}>{consultants.length}명</span>
        </div>
        <div style={S.sub}>누르면 누구에게 배정할지 고를 수 있어요. 마케터 카드로 끌어 놓아도 됩니다.</div>
        <div style={S.criteria}>{basisLabel}에 1:1 배정이 없는 행사지원 직원</div>
      </div>
      <div style={S.body}>
        <input
          type="search"
          style={S.search}
          value={keyword}
          onChange={(event) => setKeyword(event.target.value)}
          placeholder="직원 검색"
        />
        {filtered.length === 0 ? (
          <div style={S.empty}>
            <span>{keyword.trim() ? '검색 결과 없음' : '배정 안 된 직원이 없습니다'}</span>
            {keyword.trim() && (
              <button type="button" style={S.clearBtn} onClick={() => setKeyword('')}>
                검색 초기화
              </button>
            )}
          </div>
        ) : filtered.map((user) => {
          const retire = retireLabel(user);
          return (
            <button
              key={user.id}
              type="button"
              style={S.item}
              draggable={!saving}
              onDragStart={(event) => {
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', `consultant:${user.id}`);
                onDragStart(user);
              }}
              onDragEnd={onDragEnd}
              onClick={() => onPick?.(user)}
              disabled={saving}
              title={`${user.name || '-'} ${user.department || ''}`}
            >
              <div style={S.row}>
                <div style={S.name}>
                  {user.name || '-'}
                  {retire && <span style={S.badge}>{retire}</span>}
                </div>
                <div style={S.meta}>{user.department || '부서 없음'}</div>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
